import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUser: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="user, people, person, member"><path d="M15.5977 12.3584C18.2094 13.682 19.9999 16.398 20 19.5205C20 20.3336 19.3411 21 18.5225 21H5.47754C4.65889 21 4 20.3336 4 19.5205C4.00006 16.3983 5.79001 13.6821 8.40137 12.3584C9.41903 13.0766 10.6597 13.5 12 13.5C13.34 13.5 14.5801 13.0763 15.5977 12.3584Z" fill="currentColor"/><path d="M12 2.5C14.6234 2.5 16.75 4.62665 16.75 7.25C16.75 9.87335 14.6234 12 12 12C9.37665 12 7.25 9.87335 7.25 7.25C7.25 4.62665 9.37665 2.5 12 2.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconUser;
